import React from "react";
import PropTypes from "prop-types";

import ClientCompanySelectionCard from "../../../components/Clients/ClientCompanySelectionCard";

const ClientCompanySelectionView = ({
  welcomeTitle,
  welcomeSubtitle,
  sectionTitle,
  activeCountLabel,
  partnerLabel,
  selectAriaLabel,
  lang,
  companies,
  onSelectCompany,
}) => (
  <div className="client-company-selection w-100" data-auth-portal="client">
    <header className="client-company-selection__header">
      <h1 className="client-company-selection__title">{welcomeTitle}</h1>
      <p className="client-company-selection__subtitle">{welcomeSubtitle}</p>
    </header>

    <section
      className="client-company-selection__section"
      aria-labelledby="client-company-selection-heading"
    >
      <div className="client-company-selection__section-head">
        <h2
          id="client-company-selection-heading"
          className="client-company-selection__section-title"
        >
          {sectionTitle}
        </h2>
        <span className="client-company-selection__active-count">
          {activeCountLabel}
        </span>
      </div>

      <div className="client-company-selection__list">
        {companies.map((company) => (
          <ClientCompanySelectionCard
            key={company.id}
            company={company}
            lang={lang}
            partnerLabel={partnerLabel}
            selectAriaLabel={selectAriaLabel}
            onSelect={onSelectCompany}
          />
        ))}
      </div>
    </section>
  </div>
);

ClientCompanySelectionView.propTypes = {
  welcomeTitle: PropTypes.string.isRequired,
  welcomeSubtitle: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  activeCountLabel: PropTypes.string.isRequired,
  partnerLabel: PropTypes.string.isRequired,
  selectAriaLabel: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
  ).isRequired,
  onSelectCompany: PropTypes.func.isRequired,
};

export default ClientCompanySelectionView;
